import { render, staticRenderFns } from "./Autorizaciones.vue?vue&type=template&id=683bb6e8&scoped=true"
import script from "./Autorizaciones.vue?vue&type=script&lang=js"
export * from "./Autorizaciones.vue?vue&type=script&lang=js"
import style0 from "./Autorizaciones.vue?vue&type=style&index=0&id=683bb6e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683bb6e8",
  null
  
)

export default component.exports